import { useEffect, useState } from "react";
import http from "@/lib/http";

let cache = null;
let fetchedAt = 0;
let inflight = null;
const TTL = 120000; // 2 min — één fetch gedeeld door alle componenten

export async function fetchSyncHealth(force = false) {
  const now = Date.now();
  if (!force && cache && now - fetchedAt < TTL) return cache;
  if (!inflight) {
    inflight = http
      .get("/api/sync/health")
      .then((r) => {
        cache = r.data;
        fetchedAt = Date.now();
        return cache;
      })
      .catch(() => cache)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export default function useSyncHealth() {
  const [health, setHealth] = useState(cache);
  useEffect(() => {
    let on = true;
    fetchSyncHealth().then((h) => {
      if (on) setHealth(h);
    });
    const iv = setInterval(() => {
      fetchSyncHealth(true).then((h) => {
        if (on) setHealth(h);
      });
    }, TTL);
    return () => {
      on = false;
      clearInterval(iv);
    };
  }, []);
  return { health };
}

export function relTime(iso) {
  if (!iso) return "nog nooit";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return "zojuist";
  const h = Math.floor(ms / 3600000);
  if (h < 1) {
    const m = Math.max(1, Math.floor(ms / 60000));
    return `${m} min geleden`;
  }
  if (h < 48) return `${h} uur geleden`;
  return `${Math.floor(h / 24)} dagen geleden`;
}

export function fmtDT(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("nl-BE", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}
